import React from "react";

export default function NotificationFilter(props) {
  const handleReadStatus = (notificationFilter, important = "0") => {
    // props.readStatusRowMethod(readStatus, important);

    props.checkNotificationAvailabilityMethod(notificationFilter);
  };

  return (
    <>
      <div className="notfication-panel-head d-flex justify-content-between align-items-center">
        <ul className="d-flex list-unstyled m-0 read-unread-tab-pill nav nav-tabs border-0">
          <li className="pill-nav-item">
            <a
              data-toggle="pill"
              className="active"
              href="#all"
              onClick={() => {
                props.handleSearchFilterText("");
                handleReadStatus("all", "today");
              }}
            >
              All
            </a>
          </li>
          <li className="pill-nav-item">
            <a
              data-toggle="pill"
              href="#unread"
              onClick={() => {
                props.handleSearchFilterText("");
                handleReadStatus("unread", "today");
              }}
            >
              Unread
            </a>
          </li>
          <li className="pill-nav-item">
            <a
              data-toggle="pill"
              href="#important"
              onClick={() => {
                props.handleSearchFilterText("");
                handleReadStatus("important", "today");
              }}
            >
              Important
            </a>
          </li>
        </ul>
        <div className="sec-search-notfication">
          <div className="fa-ic-search">
            <i className="fal fa-search"></i>
          </div>
          <input
            value={props.searchFilterText}
            onChange={(e) => props.handleSearchFilterText(e.target.value)}
            type="search"
            className="form-control"
            placeholder="Search"
          />
        </div>
        {/* <div className="sort-by">
          <div className="form-inline">
            <label>By</label>
            <select className="form-control">
              <option>Date</option>
            </select>
          </div>
        </div> */}
      </div>
    </>
  );
}
